import { render, staticRenderFns } from "./comOndoorOrders.vue?vue&type=template&id=52f70a5c&scoped=true"
import script from "./comOndoorOrders.vue?vue&type=script&lang=js"
export * from "./comOndoorOrders.vue?vue&type=script&lang=js"
import style0 from "./comOndoorOrders.vue?vue&type=style&index=0&id=52f70a5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f70a5c",
  null
  
)

export default component.exports